import React from "react";
import { Space, Tag } from "antd";

const isWipLabel = (name) => name?.toLowerCase() === "wip";

const StatChips = ({ stats }) => (
  <div className="stat-chips-container">
    <Space wrap size="small" className="stat-chips">
      <Tag color="blue">Open: {stats.open}</Tag>
      <Tag color="orange">Due Soon: {stats.dueSoon}</Tag>
      <Tag color="red">Overdue: {stats.overdue}</Tag>
      <Tag color="magenta">Exceeded: {stats.exceeded}</Tag>
    </Space>

    {stats.byLabel?.length > 0 && (
      <Space wrap size="small" className="stat-chips stat-chips--labels">
        {stats.byLabel.map((label) => (
          <Tag
            key={label.name}
            color={isWipLabel(label.name) ? undefined : label.color || "blue"}
            className={
              isWipLabel(label.name)
                ? "issue-tag issue-tag--wip stat-label-tag"
                : "stat-label-tag"
            }
          >
            {label.name}: {label.count}
          </Tag>
        ))}
      </Space>
    )}
  </div>
);

export default StatChips;
